import React from 'react';

function Logo(props) {
    return <img alt="Logo" width="104px" height="48.386px" src="/static/logo.png" {...props} />;
}

export default Logo;
